// angular import
import { Component, Input } from '@angular/core';
import { NavigationItem } from '../../navigation';
import { animate, style, transition, trigger } from '@angular/animations';
import { ThemeConfig } from 'src/app/app-config';
import { CommonService } from '../../../../../../shared/common.service';
import { MouseInput } from 'hammerjs';

@Component({
  selector: 'app-nav-collapse',
  templateUrl: './nav-collapse.component.html',
  styleUrls: ['./nav-collapse.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)', display: 'block' }),
        animate('250ms ease-in', style({ transform: 'translateY(0%)' }))
      ]),
      transition(':leave', [animate('250ms ease-in', style({ transform: 'translateY(-100%)' }))])
    ])
  ]
})
export class NavCollapseComponent {
  // public props
  @Input() item: NavigationItem;
  visible = false;
  config = ThemeConfig;
  themeLayout = ThemeConfig.layout;
  constructor(private commonService: CommonService) {
    this.commonService.openAccountingPeriodList.subscribe((data: any) => {
        this.navCollapse(this.commonService.MouseEvent);
    })
  }
  // public method
  navCollapse(e: MouseEvent,isClicked?) {
    //debugger
    var toggele = false
    this.visible = !this.visible;
    let parent = e?.target as HTMLElement;
    if (this.themeLayout === 'vertical') {
      parent = (parent as HTMLElement)?.parentElement as HTMLElement;
    }

    const sections:any = document.querySelectorAll('.pcoded-hasmenu');
    for (let i = 0; i < sections.length; i++) {
      if ((sections[i] !== parent && window.location.pathname != "/computation" && window.location.pathname != "/notes" && (this.commonService.NotesList?.filter(x => x.NotesDescription?.toLowerCase() == this.commonService.NotesName?.toLowerCase())?.length == 0) && (this.commonService.NotesName != "accounts") && (this.commonService.NotesName != "previous period accounts data") && !parent?.textContent.includes(' Computations ') && !parent?.textContent.includes(' iXBRL Reports ') && (localStorage.getItem("Computations_Reports") != "true")) || (parent?.innerText == " Accounts" || parent?.innerText == " Tools" || parent?.innerText == " Reports" || parent?.innerText != undefined)) {
        sections[i].classList.remove('pcoded-trigger'); 
      }
    }
    if (parent?.innerText != " Accounts" && parent?.innerText != undefined && !parent?.textContent.includes(' iXBRL Reports  Accounts ') && !parent?.textContent.includes(' Import   Previous period accounts data ') && !parent?.textContent.includes(' Computations ') && !parent?.textContent.includes(' iXBRL Reports ') && !parent?.textContent.includes(' Import ') && !parent?.textContent.includes(' Tools ') && window.location.pathname != "/computation" && (this.commonService.NotesName != "accounts") && (this.commonService.NotesName != "previous period accounts data")  && (localStorage.getItem("Computations_Reports") != "true")) {
      if (!sections[0]?.classList.contains('pcoded-trigger') && sections[0]?.innerText.includes('Accounts'))
        sections[0].classList.add('pcoded-trigger');
      if (window.location.pathname == "/notes") {
        if (!sections[1].classList.contains('pcoded-trigger') && !isClicked)
          sections[1].classList.add('pcoded-trigger');
      }
      if (window.location.pathname == "/balancesheet")
        sections[1].classList.remove('pcoded-trigger');

    }
    else if (window.location.pathname == '/accountingperiod') {
      if (!sections[3]?.classList.contains('pcoded-trigger') && sections[0]?.innerText.includes('Accounts'))
        sections[0].classList.add('pcoded-trigger');
    }
    if ((parent?.innerText.includes(" Computations") || parent?.innerText.includes(" Tools") || parent?.innerText.includes(" Reports")) && (window.location.pathname != "/business")) {
      sections[0].classList.remove('pcoded-trigger');
      //sections[3].classList.remove('pcoded-trigger');
      //sections[2].classList.add('pcoded-trigger'); || window.location.pathname == "/computation"
    }
    else if (window.location.pathname == "/computation") {
      sections[0].classList.remove('pcoded-trigger');
      //sections[6].classList.remove('pcoded-trigger');
      //sections[5].classList.remove('pcoded-trigger');
      //sections[4].classList.remove('pcoded-trigger');
      //if (this.commonService.NotesName!="accounts")
           sections[2].classList.add('pcoded-trigger');
    }
    //else if (window.location.pathname == "/accountingperiod" && !parent?.innerText.includes("Computations")) {
    //  if (localStorage['Computations_Reports']!='true')
    //      sections[0].classList.add('pcoded-trigger');
    //  if (sections[2].classList.contains('pcoded-trigger'))
    //     sections[2].classList.remove('pcoded-trigger');
    //  sections[4].classList.remove('pcoded-trigger');
    //  sections[5].classList.remove('pcoded-trigger');
    //}
    //else if (parent?.textContent.includes(' Import ')) {
    //  sections[3].classList.add('pcoded-trigger');
    //}
    //else if (parent?.textContent.includes(' iXBRL Reports ')) {
    //  if ((this.commonService.AccountTemplateId != 2 && this.commonService.AccountTemplateId != 3 && this.commonService.AccountTemplateId != 8) || (this.commonService.AccountTypeId == 3)) {
    //    sections[3].classList.add('pcoded-trigger');
    //  }
    //  else
    //  sections[5].classList.add('pcoded-trigger');
    //}
    if (window.location.pathname == "/user-accounts") {
      toggele = true
      if (localStorage.getItem("APPeriodId") == "null")
        sections[0].classList.remove('pcoded-trigger');
      if (!isClicked) {
        if (localStorage.getItem("APPeriodId") == "null" || localStorage.getItem("APPeriodId") == undefined)
          sections[0].classList.add('pcoded-trigger');
        else if ((this.commonService.AccountTemplateId != 2 && this.commonService.AccountTemplateId != 3 && this.commonService.AccountTemplateId != 8) || (this.commonService.AccountTypeId == 3)) {
          sections[2].classList.add('pcoded-trigger');
          sections[0].classList.remove('pcoded-trigger');
        }
        else {
          sections[4].classList.add('pcoded-trigger');
          sections[0].classList.remove('pcoded-trigger');
        }
      }
    }
    if (this.commonService.NotesName == 'status' || window.location.pathname == "/formstatus") {
      sections[0].classList.remove('pcoded-trigger');
    }
   
    let first_parent = parent?.parentElement;
    let pre_parent = ((parent as HTMLElement)?.parentElement as HTMLElement)?.parentElement as HTMLElement;
    if (pre_parent?.innerText.includes('Basic Information')) {
      this.commonService.preparent = pre_parent;
    }
    if ((pre_parent?.innerHTML != "" && !parent?.textContent.includes(' Notes Menu ') && !parent?.textContent.includes(' Import ') && !parent?.textContent.includes(' iXBRL Reports ') && !parent?.textContent.includes(" Computations "))) {
      pre_parent?.classList.add('pcoded-submenu')
    }
    if (first_parent?.classList.contains('pcoded-hasmenu')) {
      do {
        first_parent.classList.add('pcoded-trigger');
        first_parent = ((first_parent as HTMLElement).parentElement as HTMLElement).parentElement as HTMLElement;
      } while (first_parent.classList.contains('pcoded-hasmenu'));
    } else if (pre_parent?.classList.contains('pcoded-submenu')) {
      do {
        pre_parent.parentElement.classList.add('pcoded-trigger');
        //sections[0].classList.remove('pcoded-trigger');
        pre_parent = (((pre_parent as HTMLElement).parentElement as HTMLElement).parentElement as HTMLElement).parentElement as HTMLElement;
      } while (pre_parent.classList.contains('pcoded-submenu'));
    }
    parent?.classList.toggle('pcoded-trigger');
  }

}
